var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSettingPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6063 7.6498C16.6063 9.91417 14.7706 11.7498 12.5063 11.7498C10.2419 11.7498 8.40625 9.91417 8.40625 7.6498C8.40625 5.38544 10.2419 3.5498 12.5063 3.5498C14.7706 3.5498 16.6063 5.38544 16.6063 7.6498Z",
    stroke: "#8E96A0",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00781 22.0992V22.0992C4.00781 17.8742 7.43283 14.4492 11.6578 14.4492H13.3578C17.5828 14.4492 21.0078 17.8742 21.0078 22.0992V22.0992",
    stroke: "#8E96A0",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSettingPerson);
export default __webpack_public_path__ + "static/media/icon_setting_person.31a32456dd6d52f8b2df2dbd358e1e29.svg";
export { ForwardRef as ReactComponent };